export default __webpack_public_path__ + "static/media/detalle-atleta.3ca8cf91.png";